import request from '@/utils/request';

export function getKEVRSecondaryCategoriesAsKeyValuePairList() {
  return request({
    url: '/api/kevrsecondarycategory/GetKEVRSecondaryCategoriesAsKeyValuePairList',
    method: 'get',
  });
}
